// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AnalysisSection_wrapper__n9icj","nushellDiv":"AnalysisSection_nushellDiv__mfrsQ","snippetDiv":"AnalysisSection_snippetDiv__X7djj"};